export const getProductCode = (product) => `${product.style}${product.size ? `--${product.size}` : ""}`;

export function noop() {}

export let alwaysTrue = () => true;

export const isPremiumPage = () => /premium/.test(window.location.href);

export function isTouchDevice() {
  // https://stackoverflow.com/a/4819886/3916145
  const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");

  const mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
}

// Mixins / multiple-inheritance support. See https://gist.github.com/dfitiskin/8c70da61af29fd28efad02a88a5f2fb5
export function mix(Base, ...mixins) {
  return mixins.reduce((Base, mixin) => mixin(Base), Base);
}

class NullBaseClass {}

export function callbacksMixin(base = NullBaseClass) {
  return class extends base {
    on(eventName, callback) {
      this._callbacksFor(eventName).push(callback);
      return this;
    }

    _trigger(eventName, ...args) {
      this._callbacksFor(eventName).forEach((cb) => cb.apply(this, args));
    }

    _callbacksFor(eventName) {
      this._callbacks = this._callbacks || {};
      return (this._callbacks[eventName] = this._callbacks[eventName] || []);
    }
  };
}

/**
 * Gets test group number.
 * @param testBits {array<number>} Array of bits, starting at 0, to determine test group, e.g. [0,2] use first and third bit.
 * @param hash {number} Numeric hash to extract test group
 * @returns {number}
 */
export function getTestGroup(testBits, hash) {
  const valueAtBit = (bitIndex) => (hash >> bitIndex) & 0b1;

  let result = 0;
  testBits.forEach((bitIndex, idx) => {
    if (valueAtBit(bitIndex) === 1) {
      result += Math.pow(2, idx);
    }
  });

  return result;
}
